/*=========================================================================================
  File Name: moduleEcommerceActions.js
  Description: Ecommerce Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import axios from '@/axios.js';

export default {
  toggleItemInWishList({commit}, item) {
    commit('TOGGLE_ITEM_IN_WISH_LIST', item)
  },
  toggleItemInCart({commit}, item) {
    commit('TOGGLE_ITEM_IN_CART', item)
  },
  additemInCart({commit}, item) {
    item["quantity"] = 1
    item["discount_in_percentage"] = Math.floor(Math.random() * 20) + 4
    item["offers_count"] = Math.floor(Math.random() * 4) + 1
    item["delivery_date"] = new Date(new Date().getTime() + (Math.random() * 10 * 24 * 60 * 60 * 1000)).toDateString().slice(0, -4)
    commit('ADD_ITEM_IN_CART', item)
  },
  updateItemQuantity({commit}, payload) {
    commit('UPDATE_ITEM_QUANTITY', payload)
  },
  setAddress({commit}, payload) {
    commit('SET_ADDRESS', payload)
  },
  async setOrder({commit, state}, {proDis}) {
    let {data} = await axios.post('customer/order/set', {
      items: state.cartItems,
      proDis: proDis,
      disCode: state.coupon,
      address: state.address,
      total: state.total,
      shippingCost: state.shippingCost
    });
    return data;
  },
  flush({commit}) {
    commit('FLUSH');
  },
  async refund({commit, state}, payload) {
    let {data} = await axios.post('customer/order/refund', payload);
    return data;
  },
  async checkCoupon({commit, state}, code) {
    try {
      commit('FLUSH_COUPON');
      let {data} = await axios.post('customer/check-coupon', {
        code: code, pid: state.cartItems.map((i) => {
          return {id: i.id, qty: i.qty};
        })
      });
      commit('CALC_COUPON', data);
      return data;
    } catch (e) {
      console.log("e ==> ", e);
      throw e;
    }
  },

  async removeCoupon({commit}){
    commit('FLUSH_COUPON');
  },
  async fetchCart({commit}) {
    let items = JSON.parse(localStorage.getItem('cart_items')) || [];
    commit('SERVER_INIT');
    const isLogin = () => {
      return localStorage.getItem('accessToken') != undefined;
    };
    if (items.length > 0) {
      let {data} = await axios.post('api/site/get-cart-detail', {ids: items});
      if (data) {
        let exp = [];
        for (let ci of items) {
          let qv = data.find((item) => ci.pid == item.id);
          if (qv) {
            let v = qv.variants.find((item) => item.id == ci.vid);
            if (v) {
              qv.v = v;
              qv.qty = ci.qty || 1;
              qv.price = (isLogin() ? v.price : v.original_price) * qv.qty;
              exp.push(qv);
            }
          }
        }
        commit('INIT', exp);
      }
    }
  }
}
